// extracted by mini-css-extract-plugin
export var dividerLine = "_5o-0";
export var errorBackground = "_5o-1";